var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.layouts)?_c('O3D',{attrs:{"layout":"scrollLayer","animated":true}},[_c('TextureText',{attrs:{"font":"Arial","align":"left","clicked":_vm.say,"text":_vm.allText}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }